import { MotifButton, MotifCard, MotifCardBody } from '@ey-xd/motif-react';
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';

const ConversationSuccessfullyUploadedDocument = (props: any) => {
    const { content, enabledToAnswer } = props;
    const dispatch = useDispatch();
    return (
        <MotifCard className="!w-full">
            <MotifCardBody>
                <p className="text-lg font-bold">
                    {content.title}
                </p>
                <hr className='my-4' style={{ opacity: "0.1" }} />
                <div>
                    <MotifButton
                        disabled={!enabledToAnswer}
                        size="small"
                        endIcon={null}
                        onClick={function Xo() { }}
                        startIcon={null}
                    >
                        View document(s)
                    </MotifButton>
                </div>
            </MotifCardBody>
        </MotifCard>
    )
}

export default ConversationSuccessfullyUploadedDocument